// extracted by mini-css-extract-plugin
export default {"filters":"ReportUI_filters__N4QbD"};